import { ChevronLeftIcon } from "@heroicons/react/outline";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TutorModel from "../../api/models/TutorModel";
import TutorInfoModal from "../modal/TutorInfoModal";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
type TutorCardProps = {
  tutor: TutorModel;
};

export default function TutorCard(props: TutorCardProps) {
  const { tutor } = props;
  const LocalBasePath = "page.supervisor.tutor";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });
  const [open, setOpen] = useState<boolean>(false);
  return (
    <>
      <div className="w-full  h-[138px] p-4 bg-white rounded-lg shadow flex-col justify-center  gap-4 inline-flex">
        <div className="self-stretch justify-end items-center gap-4 inline-flex">
          <UserProfilePictureAvatar
            className="w-10 h-10 rounded-full"
            profilePictureUrl={tutor?.profile_picture_url}
          />

          <div className="w-full flex  flex-col ">
            <div className="self-stretch grow shrink basis-0  items-center gap-1 inline-flex">
              <div className=" text-gray-900 text-sm font-medium">
                {tutor?.fullNameWithoutMiddle}
              </div>

              <div className="px-2 py-1 bg-green-50 rounded-lg justify-center items-center gap-1.5 flex">
                <div className="text-green-700 text-xs leading-5 font-normal">
                  {t("seals", {
                    count:
                      (tutor?.statistics?.number_of_khetma_courses ?? 0) +
                      (tutor?.statistics?.number_of_ejaza_courses ?? 0),
                  })}
                </div>
                {/* <div className=" items-center   rounded w-[17px] h-4 flex justify-center text-[8px] leading-3  bg-green-700 text-white">
                  {"+3"}
                </div> */}
              </div>
            </div>
            <div className="w-full flex    text-gray-500 text-xs font-normal">
              {tutor?.account?.email}
            </div>
          </div>
          <div className="w-6 h-6 relative">
            <ChevronLeftIcon
              onClick={() => setOpen(true)}
              className="w-6 h-6 text-gray-500 cursor-pointer ltr:rotate-180"
            />
          </div>
        </div>
        <div className="self-stretch pt-2 border-t border-gray-100 justify-center items-end inline-flex">
          <div className="grow     h-full  shrink basis-0 flex-col justify-center items-center gap-0.5 inline-flex">
            <div className="self-stretch justify-center items-center gap-1.5 inline-flex">
              <div className="text-center text-gray-400 text-[12px] font-normal leading-none">
                {t("canceled")}
              </div>
            </div>
            <div className="self-stretch text-center text-gray-700 text-[14px] font-medium leading-tight">
              {tutor?.statistics?.number_of_canceled_sessions_by_tutor}
            </div>
          </div>
          <div className="grow h-full  border-x border-gray-100    shrink basis-0 flex-col justify-center items-center gap-0.5 inline-flex">
            <div className="self-stretch text-center text-gray-400 text-[12px] font-normal leading-tight">
              {t("absence")}
            </div>
            <div className="self-stretch text-center text-gray-700 text-[14px] font-medium leading-tight">
              {tutor?.statistics?.number_of_absences_by_tutor}
            </div>
          </div>

          <div className="h-full grow shrink   basis-0 flex-col justify-center items-center gap-0.5 inline-flex">
            <div className="self-stretch text-center text-gray-400 text-xs font-normal leading-5">
              {t("delay")}
            </div>
            <div className="self-stretch text-center text-gray-700 text-[14px] font-medium leading-tight">
              {tutor?.tardiness}
            </div>
          </div>
        </div>
      </div>

      <TutorInfoModal
        open={open}
        onClose={() => setOpen(false)}
        tutor={tutor}
        setIsOpen={() => setOpen(false)}
        cancel={open}
      />
    </>
  );
}
